import * as React from 'react';
import { AddToCart } from './AddToCart';
import { MoreInfo } from '../MoreInfo';
import classNames from 'classnames';

export function NftCard(props) {
  const [inCart, setInCart] = React.useState(
    props.inCartStatus[props.id] || false
  );
  const [isSold, setIsSold] = React.useState(
    props.sold?.[props.id] === undefined ? false : props.sold?.[props.id]
  );
  React.useEffect(() => {
    setInCart(props.inCartStatus[props.id] || false);
    setIsSold(
      false || props.sold?.[props.id] === undefined
        ? false
        : props.sold?.[props.id]
    );
  }, [props.inCartStatus, props.id, props.sold, props]);

  function handleClick(id) {
    if (!inCart) {
      props.addToCart(id);
    } else {
      props.removeFromCart(id);
    }
  }
  const market = `https://opensea.io/assets/0x71664391476F32CD98cfd07230B4F00A0a2Dc19C/${props.id}`;
  const imageUrl =
    props.id === 87
      ? 'https://i0.wp.com/cerjlalonde.com/wp-content/uploads/2023/03/SKYFACE-87.0.jpg?fit=1030%2C1030&ssl=1'
      : `https://i0.wp.com/cerjlalonde.com/wp-content/uploads/2022/11/SKYFACE-${props.id}.0.jpg?fit=1030%2C1030&ssl=1`;

  return (
    <div className='card card-compact max-w-full bg-base-100 shadow-xl relative'>
      {isSold && (
        <div
          className={classNames(
            'absolute top-0 right-0 bg-green-500 text-white text-xs py-1 px-2 rounded-bl',
            {
              'mt-2 mr-2': inCart,
              'mt-4 mr-4': !inCart,
            }
          )}
        >
          <span
            href='https://opensea.io/assets/ethereum/0x71664391476F32CD98cfd07230B4F00A0a2Dc19C/'
            target='_blank'
            rel='noopener noreferrer'
            style={{ fontWeight: 'bold' }}
          >
            SOLD
          </span>
        </div>
      )}
      <figure>
        {inCart && (
          <button
            className='absolute top-2 right-2 text-red-500'
            onClick={() => handleClick(props.id)}
          >
            X
          </button>
        )}
        <img
          className='max-w-full h-auto'
          src={imageUrl}
          alt={`SKYFACE ${props.id}.0`}
        />
        {/*87 url https://i0.wp.com/cerjlalonde.com/wp-content/uploads/2023/03/SKYFACE-87.0.jpg?fit=1030%2C1030&ssl=1}*/}
      </figure>
      <div className='card-body items-center text-center'>
        <h3 className='card-title'>SKYFACE - {props.id}.0</h3>

        <MoreInfo
          id={props.id}
          image={imageUrl}
          price={props.eth}
          bigPrice={props.bigPrice}
          cart={props.cart}
          inCart={inCart}
          handleClick={handleClick}
          setInCart={setInCart}
          isSold={isSold}
        />

        <div className='card-actions justify-end'>
          <AddToCart
            id={props.id}
            cart={props.cart}
            ethPrice={props.ethPrice}
            bigPrice={props.bigPrice}
            inCart={inCart}
            handleClick={handleClick}
            setInCart={setInCart}
            isSold={isSold}
          />
        </div>
      </div>
    </div>
  );
}
